module.exports = __webpack_public_path__ + "img/all-data-bg.fb7ac68d.svg";